import { Container } from "components/atoms";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAllSettingsAction } from "store/middlewares/settings/settings";

export function Footer() {
  const currentYear = new Date().getFullYear();
  const dispatch = useDispatch();
  const { settings } = useSelector((state) => state.settings);

  useEffect(() => {
      dispatch(GetAllSettingsAction());
    }, [dispatch]);

  return (
    <footer className="footer">
      <Container>
        <div className="flex flex-col md:flex-row justify-center md:justify-between items-center gap-3 py-5">
          <div className="flex order-2 md:order-1  gap-2 font-normal text-sm">
            <span className="text-muted-foreground">{currentYear} &copy;</span>
            <a
              href="/dashboard"
              className="text-secondary-foreground hover:text-primary"
            >
             {settings?.app_name}
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
}
